/** CMM columns requested for all Primary Care orders table API calls (fetch and search). */
export const PRIMARY_CARE_TABLE_CMM_FIELDS = [
  "cmm_status",
  "error_text",
  "cmm_result_key",
] as const;
